import React from 'react';
import { FaTimes } from 'react-icons/fa';

const NurseDetailModal = ({ isOpen, onClose, nurse, onBookSession }) => {
  if (!isOpen || !nurse) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCheckAvailability = () => {
    if (onBookSession) {
      onBookSession(nurse.id);
    }
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto relative">
        {/* Close Button - Top Right Corner */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors z-10"
        >
          <FaTimes className="w-5 h-5 text-gray-600" />
        </button>

         <div className="flex items-center gap-6 mb-5">
          <div>
            <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
              
            </h1>
          </div>
        </div>


          {/* Profile Content */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6">
              <div className="flex flex-col lg:flex-row">
                {/* Profile Picture Section - Left Side (1/3 width) */}
                <div className="lg:w-1/2 flex flex-col items-center justify-start mr-6">
                  <div className="w-3/4 h-full relative rounded-lg overflow-hidden bg-transparent flex items-start justify-center">
                  <img
                    className="max-w-full object-contain transition-all duration-300 cursor-pointer"
                    src={nurse.bigImage}
                    alt={`${nurse.name} Profile`}
                  />
                  </div>
                </div>


                {/* Details Section - Right Side (2/3 width) */}
                <div className="flex flex-col item-center justify-between lg:w-1/2 pl-5">
                  <div>
                      {/* User Identification */}
                      <div className="mb-6 flex items-center justify-center">
                        <div className="flex flex-col items-center text-center">
                          <h3 class="font-semibold text-xl text-gray-900 text-left">
                            {nurse.name}
                          </h3>
                          <p className="text-gray-600 text-sm mt-2">
                            {nurse.qualifications || "Not Availble"}
                          </p>
                        </div>
                      </div>

                      {/* Profile Information */}
                      <div className="space-y-6 mb-8">
                        {/* Description */}
                        <div className="space-y-3"> 
                          {nurse.description?.map((desc, index) => (
                            <p key={index} className="text-gray-700 leading-relaxed">
                              {desc}
                            </p>
                          ))}
                        </div>
                      </div> 
                  </div>

                  {/* Action Button */}
                  <div className="flex w-full items-center justify-center mt-8">
                    <div
                      onClick={handleCheckAvailability}
                      className="text-blue-600 leading-relaxed hover:underline cursor-pointer"
                    >
                      Check Availability
                    </div>
                  </div> 
            

                </div>

              </div>
              
   
          </div>

      </div>
    </div>
  );
};

export default NurseDetailModal;
